import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import { ThemeProvider } from '@emotion/react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-light-svg-icons'

import * as brandActions from 'agency/redux/modules/brand'
import * as campaignActions from 'agency/redux/modules/campaign'
import * as campaignProposalActions from 'agency/redux/modules/campaignProposal'
import * as currentUserActions from 'agency/redux/modules/currentUser'
import * as digitalPageActions from 'agency/redux/modules/digitalPage'

import useMixpanel from 'hooks/useMixpanel'

import theme from 'suitTheme/theme'

import 'styles/reset.css'
import 'react-toastify/dist/ReactToastify.css'
import 'styles/toast.scss'

import './styles.scss'

const CloseButton = ({ closeToast }) => (
  <a onClick={closeToast}>
    <FontAwesomeIcon icon={faTimes} />
  </a>
)

const hydrateEntities = (props) => {
  const { entities } = props

  entities.forEach(({ data, select, type }) => {
    const hydrateFn = props[`hydrate${type}`]
    const selectFn = props[`select${type}`]

    if (hydrateFn) hydrateFn(data)
    if (select && selectFn) selectFn(data)
  })
}

const DigitalRenderer = (props) => {
  const { children, currentUser, hydrateCurrentUser } = props

  useEffect(() => {
    hydrateCurrentUser(currentUser)
    hydrateEntities(props)
  }, [])

  useMixpanel()

  return (
    <ThemeProvider theme={theme}>
      {children}
      <ToastContainer closeButton={<CloseButton />} hideProgressBar autoClose={3000} />
    </ThemeProvider>
  )
}

DigitalRenderer.propTypes = {
  currentUser: PropTypes.object.isRequired,
  entities: PropTypes.array.isRequired,
}

function mapStateToProps(){
  const {
    dashboardSettings: { currentUser, entities },
  } = window

  return {
    currentUser,
    entities,
  }
}

const mapDispatchToProps = {
  hydrateBrand: brandActions.hydrateBrand,
  hydrateCampaign: campaignActions.hydrateCampaign,
  hydrateCampaignProposal: campaignProposalActions.hydrateCampaignProposal,
  hydrateCurrentUser: currentUserActions.hydrateCurrentUser,
  hydrateDigitalPage: digitalPageActions.hydrateDigitalPage,
  selectCampaignProposal: campaignProposalActions.selectCampaignProposal,
  selectDigitalPage: digitalPageActions.selectDigitalPage,
}

export default connect(mapStateToProps, mapDispatchToProps)(DigitalRenderer)
